var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "max-height": "50vh", "overflow-y": "auto" },
      style: _vm.commonStyle,
    },
    [
      _c("Editor", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { init: _vm.init },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }